'use strict';

const QuantityPresenter = require('../presenters/quantity');

const BaseView = require('./base');

class QuantityView extends BaseView {
  tagName() {
    return 'div';
  }

  initialize() {
    this.module = 'glive_booking_redesign';
    this.presenter = QuantityPresenter;
    this.templateName = 'quantity';
  }

  className() {
    return 'quantity';
  }

  events() {
    return { click: 'select' };
  }

  select(args, kill = false) {
    if (!kill) {
      $(args.toElement).trigger('click', true);
      this.trigger('select', this.model);
    }
  }
}

module.exports = QuantityView;
